export enum Language {
    Pl = "pl",
    Eng = "eng",
    Dev = "dev"
}
